import React from 'react';
import { Box, CircularProgress } from '@mui/material';

const RouteLoading = () => {
    return (
        <Box
            sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 200,
                height: 200,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <CircularProgress
                size={64}
                sx={{
                    color: 'primary.main',
                }}
            />
        </Box>
    );
};

export default RouteLoading;
